const WishlistButton = {
  init() {
    this.setupEventListeners();
    this.shop = Shopify.shop;
    this.accessToken = '{{ shop.permanent_domain }}'; // This should be replaced with a secure method to obtain the access token
  },

  setupEventListeners() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('.wishlist-button')) {
        this.handleWishlistButtonClick(event);
      }
    });
  },

  handleWishlistButtonClick(event) {
    const button = event.target.closest('.wishlist-button');
    const productId = button.dataset.productId;
    this.toggleWishlistItem(productId, button);
  },

  async toggleWishlistItem(productId, button) {
    try {
      const response = await fetch('https://shopify-wishlist-ri4dlujxf-breeziguys-projects.vercel.app/api/wishlist/toggle', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          productId,
          shop: this.shop,
          accessToken: this.accessToken
        }),
        credentials: 'include'
      });

      if (response.ok) {
        const { inWishlist } = await response.json();
        this.updateButtonState(button, inWishlist);
      } else {
        console.error('Failed to toggle wishlist item');
      }
    } catch (error) {
      console.error('Error toggling wishlist item:', error);
    }
  },

  updateButtonState(button, inWishlist) {
    const textElement = button.querySelector('.wishlist-button__text');
    if (inWishlist) {
      textElement.textContent = 'Remove from Wishlist';
      button.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      textElement.textContent = 'Add to Wishlist';
      button.setAttribute('aria-label', 'Add to wishlist');
    }
  },
};

document.addEventListener('DOMContentLoaded', () => {
  WishlistButton.init();
});